import * as Sentry from '@sentry/browser';

const defaultKeysToRedact = [
  'nonce',
  'password',
  'authentication',
  'threeDSecureAuthenticationId',
  'captchaToken',
];

/**
    Redacts PII in objects.
    See ./redact.spec.js to see input => output examples.
*/

function redactSensitiveKeys(obj, keysToRedactSet) {
  if (Array.isArray(obj)) {
    obj.forEach(entry => redactSensitiveKeys(entry, keysToRedactSet));
  } else if (typeof obj === 'object' && obj !== null) {
    // eslint-disable-next-line no-restricted-syntax
    for (const k in obj) {
      if (
        typeof obj[k] === 'string'
        && keysToRedactSet.has(k.toLowerCase())) {
        // eslint-disable-next-line no-param-reassign
        obj[k] = '***redacted***';
      } else if (typeof obj[k] === 'object' && obj[k] !== null) {
        redactSensitiveKeys(obj[k], keysToRedactSet);
      }
    }
  }
}

export default function redact(obj, keysToRedact = defaultKeysToRedact) {
  try {
    const keysToRedactSet = new Set(keysToRedact.map(key => key.toLowerCase()));
    const deepClone = JSON.parse(JSON.stringify(obj));
    redactSensitiveKeys(deepClone, keysToRedactSet);
    return deepClone;
  } catch (e) {
    const err = new Error(`Exception while redacting the object ${e?.message}`);
    err.name = 'RedactError';
    err.cause = e;
    Sentry.captureException(err);
    return obj;
  }
}
